module.exports = __webpack_public_path__ + "static/media/bluedot.9f1daf3a.svg";